module.exports = __webpack_public_path__ + "img/skull_8_bj.0241a428.png";